import { render, staticRenderFns } from "./CorrectCard.vue?vue&type=template&id=7d0287d2&scoped=true&"
import script from "./CorrectCard.vue?vue&type=script&lang=ts&"
export * from "./CorrectCard.vue?vue&type=script&lang=ts&"
import style0 from "./CorrectCard.vue?vue&type=style&index=0&id=7d0287d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0287d2",
  null
  
)

export default component.exports